var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SelectFilter',{attrs:{"options":_vm.options,"filterId":"personalAgent","filterName":"Personal Agent"},on:{"hovering":_vm.onHovering,"editing":_vm.onEditing},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }